import { Link } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { agentAgencyDocumentsApi } from "../../services/agentApi";
import { AgencyDocumentsWorkspace } from "../../../../shared/src/components/agency-documents/AgencyDocumentsWorkspace";
export function AgencyDocumentsPage() {
  const { user } = useAuth();
  return (
    <div className="container py-4">
      <Link className="d-inline-block mb-3" to="/profile">
        ← Back to profile
      </Link>
      <AgencyDocumentsWorkspace
        accountKey={String(user?.id || "signed-out")}
        api={agentAgencyDocumentsApi}
      />
    </div>
  );
}
